import type { LibP2pWithServices, NodeOptions } from '@/types/poc/libp2p';

export abstract class Libp2pService {
  abstract createNode(options: NodeOptions): Promise<LibP2pWithServices>;
  abstract stopNode(node: LibP2pWithServices): Promise<void>;
  abstract subscribeToTopic(
    node: LibP2pWithServices,
    topic: string,
    handler: (message: Uint8Array) => void
  ): () => void;
  abstract publishToTopic(
    node: LibP2pWithServices,
    topic: string,
    data: Uint8Array | string
  ): Promise<void>;
}
